import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef } from '@angular/core';
import { add } from 'date-fns';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { DateService } from 'src/app/services/date.service';
import { StockService } from 'src/app/services/stock.service';
import { ToastService } from 'src/app/services/toast.service';
import { SignalElement, SignalsElement } from 'src/app/utils/signalsElements';
import {
  ComplementInformationEnum,
  ComplementInformationSignEnum,
  DimensionInformationEnum,
  IndicationVerticalEnum,
  RegulationVerticalEnum,
  SignalingTypeEnum,
  StockInputTypeEnum,
  VerticalGroupTypeEnum,
  VerticalSignalingEnum,
  VerticalSignalizationTypeEnum,
  WarningVerticalEnum,
} from 'src/enumerators';
import { WarrantyTypeEnum } from 'src/enumerators/action.enum';
import { Contract, ContractVerticalItemSign, TrafficSignTaskActivities } from 'src/models';
import * as Leaflet from 'leaflet';

@Component({
  selector: 'app-vertical-activity',
  templateUrl: './vertical-activity.component.html',
  styleUrls: ['../forms-styles.css'],
})
export class VerticalActivityComponent implements OnInit, OnChanges {
  activities: TrafficSignTaskActivities = new TrafficSignTaskActivities({});
  verticalSigns = {
    regulation: Object.values(RegulationVerticalEnum),
    warning: Object.values(WarningVerticalEnum),
    indication: Object.values(IndicationVerticalEnum),
  };
  stockInputTypeEnum = StockInputTypeEnum;
  signalizationTypes: Array<VerticalSignalizationTypeEnum> = Object.values(VerticalSignalizationTypeEnum);
  verticalSignalizationType = VerticalSignalizationTypeEnum;
  complementInformationType = ComplementInformationEnum;
  verticalItems: ContractVerticalItemSign[] = [];
  blockDimension: { dimensionXY: boolean; dimension: boolean } = { dimensionXY: false, dimension: false };
  signalsElements: SignalElement[] = Object.values(SignalsElement);
  loading: boolean = true;
  currentItem;
  currentIndex: number;
  typeSignEnum = SignalingTypeEnum; // Enum do tipo HVD
  modalsRef?: Array<BsModalRef> = [];
  lastQuantity: number;
  quantityToBeRegistered: number;
  verticalSignEnum = VerticalSignalingEnum;
  showInternalCap: boolean = true;

  // Mock-up
  today = new Date();

  radioState = [];

  @Input() trafficSignTaskActivities: any[];
  @Input() contract: Contract;
  @Input() isStock: boolean = false;
  @Input() stockEntries: any[] = [];
  @Input() activitiesTaskStreetViewList = []
  @Input() map: Leaflet.Map;;
  @Output() validationEvent = new EventEmitter<boolean>();
  @Output() addCode = new EventEmitter<{ item: any, index: number }>();
  @Output() removeCode = new EventEmitter<number>();

  constructor(
    public dateService: DateService,
    private _modalService: BsModalService,
    private _stockService: StockService,
    private _toastService: ToastService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.activitiesTaskStreetViewList?.currentValue?.length != changes.activitiesTaskStreetViewList?.previousValue?.length) {
      this.radioState = [];
      this.trafficSignTaskActivities.forEach((sign) => {
        this.radioState.push(
          sign.stockedTrafficSignId ? { contract: false, stock: true } : { contract: true, stock: false }
        );
      })
    }
  }

  ngOnInit(): void {
    this.contract?.verticalGroups.forEach((group) => {
      if (group.groupType == VerticalGroupTypeEnum.RoadSign) {
        group.verticalItems.forEach((item: ContractVerticalItemSign) => {
          this.verticalItems.push(item);
        });
      }
    });
    this.trafficSignTaskActivities.forEach((sign) => {
      this.radioState.push(
        sign.stockedTrafficSignId ? { contract: false, stock: true } : { contract: true, stock: false },
      );
      if (!sign?.verticalType) {
        sign.verticalType = this.setVerticalClass(sign?.verticalCode)
      }
      if (sign?.parentVerticalId)
        sign['quantityToBeRegistered'] = sign.quantity;

      if (sign?.contractVerticalItemId && sign.warranty) {
        this.checkForInternalCap(sign);
        if (sign?.contractVerticalItemId) {
          this.setSvg(sign);
          this.setContractItem(sign, undefined, undefined, true);
          this.setWarranty(sign.warranty, sign);

          if (sign.id) {
            this.lastQuantity = sign.quantity;
          }
          sign['quantityToBeRegistered'] = sign.quantity;
        }
        if (sign.stockedTrafficSignId) {
          this._stockService.getStockedTrafficSign(this.contract.id).subscribe((res: any) => {
            this.stockEntries = res;
          });
        }
      }
    });

    if (this.stockEntries.length) {
      this._stockService.getStockedTrafficSign(this.contract.id).subscribe((res: any) => {
        this.stockEntries = res;
      });
    }
    this.loading = false;
  }

  verifyQuantity(index) {
    if (this.trafficSignTaskActivities[index].id && this.isStock) {
      if (this.trafficSignTaskActivities[index]?.quantityToBeRegistered >= this.lastQuantity) {
        this.trafficSignTaskActivities[index].quantity = this.trafficSignTaskActivities[index]?.quantityToBeRegistered;
      } else {
        this.trafficSignTaskActivities[index].quantityToBeRegistered = this.lastQuantity;
        this._toastService.showError('A quantidade não pode ser inferior às cadastradas.');
      }
    } else if (this.trafficSignTaskActivities[index]?.id) {
      if (this.trafficSignTaskActivities[index]?.quantityToBeRegistered >= this.trafficSignTaskActivities[index]?.quantityRegistered) {
        this.trafficSignTaskActivities[index].quantity = this.trafficSignTaskActivities[index]?.quantityToBeRegistered;
      } else {
        this.trafficSignTaskActivities[index].quantityToBeRegistered = this.trafficSignTaskActivities[index]?.quantityRegistered;
        this._toastService.showError('A quantidade não pode ser inferior às cadastradas.');
      }
    } else {
      this.trafficSignTaskActivities[index].quantity = this.trafficSignTaskActivities[index]?.quantityToBeRegistered;
    }
  }

  // Remove a atividade
  removeActivity(index: number) {
    this.trafficSignTaskActivities.splice(index, 1);
    this.removeCode.emit(index);
  };

  // Defini o item do contrato para autocomplete e calculo
  setContractItem(sign: TrafficSignTaskActivities, stockedId?: string, index?: number, edit?: boolean) {
    var item: any;

    if (!stockedId) {
      item = this.verticalItems.find((item) => item.id == sign?.contractVerticalItemId);
      if (item.adjustedUnitValue) item.unitValue = item.adjustedUnitValue;
      sign.contractVerticalItem = item;

      if (!edit) {
        if (sign.contractVerticalItemId) {
          if (sign.contractVerticalItem.warrantyType == WarrantyTypeEnum.TimeInterval) {
            sign.warranty = add(new Date(), { years: sign.contractVerticalItem.warrantyYear, months: sign.contractVerticalItem.warrantyMonth })
          }
          else if (sign.contractVerticalItem.warranty) sign.warranty = new Date(sign.contractVerticalItem.warranty);
        }
      }

      sign['progress'] = 0;
      sign['active'] = 1;
      if (sign.dimension) this.calculateDimension(sign);
    } else {
      item = this.stockEntries.find((item) => item.id == stockedId).contractVerticalItem;
      let stockedItem = this.stockEntries.find((v) => v.id == stockedId);
      this.trafficSignTaskActivities[index] = new TrafficSignTaskActivities(stockedItem);
      this.trafficSignTaskActivities[index].quantity = 1;
      this.trafficSignTaskActivities[index].stockedTrafficSignId = stockedId;
      this.trafficSignTaskActivities[index].contractVerticalItem = this.verticalItems.find(
        (item) => item.id == stockedItem.contractVerticalItemId,
      );
      this.trafficSignTaskActivities[index].id = undefined;
      if (this.trafficSignTaskActivities[index].dimension)
        this.calculateDimension(this.trafficSignTaskActivities[index]);
    }
  }

  // Defini dimensao e bloqueio de inputs
  setDimension(type: 'xy' | 'total', sign: TrafficSignTaskActivities, value: number) {
    this.calculateDimension(sign);
    this.blockDimension.dimension = value !== 0 && type == 'xy' ? true : false;
  }

  // Calcula a dimensao e atribui valor à sinalização
  calculateDimension(sign: TrafficSignTaskActivities) {
    sign.cost = sign.quantity * sign.dimension * (sign?.contractVerticalItem?.unitValue || 0);
  }

  // Seta a garantia da sinalização e barra de progresso
  setWarranty(event: Date, sign: TrafficSignTaskActivities) {
    sign['warrantyTextCurrent'] = null;
    sign['warrantyCurrent'] = null;
    sign['warrantyEnd'] = null;
    sign['progress'] = 0;
    sign['active'] = 1;
    sign.warranty = event;
    const relativeTime: any[] = this.dateService.getRelativeTime(event, new Date());
    sign['warrantyTextCurrent'] = this.dateService.getTextDate(relativeTime);
    this.progressWarranty(event, sign);
  }

  //Função par auxiliar na criação da barra de progresso de garantia
  progressWarranty(warranty, sign: TrafficSignTaskActivities) {
    let now = new Date();
    sign['warrantyEnd'] = this.dateService.getRelativeTime(warranty, now);
    sign['warrantyCurrent'] = this.dateService.getRelativeTime(warranty, now);

    if (sign['warrantyCurrent'][0] || sign['warrantyEnd'][0]) {
      sign['progress'] = sign['warrantyCurrent'][0] / sign['warrantyEnd'][0];
    } else {
      sign['progress'] = 0;
    }

    if (sign['progress'] <= 0) {
      sign['active'] = 3;
    } else {
      if (
        sign['warrantyCurrent'][1] <= 0 &&
        ((sign['warrantyCurrent'][2] <= 0 && sign['warrantyCurrent'][3] <= 31) ||
          (sign['warrantyCurrent'][2] == 1 && sign['warrantyCurrent'][3] == 0))
      ) {
        sign['active'] = 2;
      } else {
        sign['active'] = 1;
      }
    }
  }

  // Atribui valor do componente de informação complementar para a sinalização
  handleComplementInformation(
    event: { type: ComplementInformationEnum; value: string; enableComplementInformation: boolean },
    sign: any,
  ) {
    sign.complementInformation = event.value;
    sign.complementInformationType = event.type;
  }

  // Retorna qual é o tipo da informação complementar sabendo qual é o tipo da placa WARNING/REGULATION
  complementType(sign): ComplementInformationSignEnum {
    if (sign.complementInformationType == ComplementInformationEnum.Additional) {
      if (sign.verticalType == VerticalSignalizationTypeEnum.Warning) {
        return ComplementInformationSignEnum.AdditionalWarning;
      } else {
        return ComplementInformationSignEnum.AdditionalRegulation;
      }
    } else {
      if (sign.verticalType == VerticalSignalizationTypeEnum.Warning) {
        return ComplementInformationSignEnum.IncorporatedWarning;
      } else {
        return ComplementInformationSignEnum.IncorporatedRegulation;
      }
    }
  }

  // Emite validação do form
  emitValidation(sign: any) {
    const validation = sign.dimension > 0 && sign.verticalCode && sign.quantity > 0;
    this.validationEvent.emit(validation);
  }

  // Atribui SVG à sinalização
  setSvg(task: TrafficSignTaskActivities) {
    task['svg'] = this.signalsElements.find((sign) => sign.name.toUpperCase() == task.verticalCode.toUpperCase());
  }

  closeModal() {
    const last: any = this.modalsRef.length - 1;
    this.modalsRef[last].hide();
    this.modalsRef.pop();
  }

  // Abre MODAL
  openModalXL(template: TemplateRef<any>) {
    const modalRefAux: BsModalRef = this._modalService.show(template, {
      class: 'modal-dialog-centered modal-xl',
      backdrop: 'static',
    });
    this.modalsRef.push(modalRefAux);
  }

  setVerticalClass(code): VerticalSignalizationTypeEnum {
    if (this.verticalSigns.indication.includes(code)) {
      return VerticalSignalizationTypeEnum.Indication;
    } else if (this.verticalSigns.warning.includes(code)) {
      return VerticalSignalizationTypeEnum.Warning;
    } else if (this.verticalSigns.regulation.includes(code)) {
      return VerticalSignalizationTypeEnum.Regulation;
    }
  }

  // Método chamado após selecionar a sinalização dentro do modal
  selectSignModal(event) {
    this.currentItem.verticalCode = event[0];
    this.currentItem.verticalType = this.setVerticalClass(this.currentItem.verticalCode);
    this.addCode.emit({ item: this.currentItem, index: this.currentIndex });
    this.checkForInternalCap(this.currentItem);
  }

  // Atribui valor do componente de dimensao para a sinalização
  handleDimensionInformation(
    event: {
      dimensionType: DimensionInformationEnum;
      dimension: number;
      dimensionX: number;
      dimensionY: number;
      units: number;
      diameter: number;
      sideLength: number;
      quantity: number;
    },
    sign,
  ) {
    sign.diameter = event.diameter;
    sign.dimension = event.dimension;
    sign.dimensionX = event.dimensionX;
    sign.dimensionY = event.dimensionY;
    sign.sideLength = event.sideLength;
    sign.dimensionType = event.dimensionType;
    this.calculateDimension(sign);
  }

  setBond(type, index) {
    if (type == 'stock') {
      this.radioState[index] = { stock: true, contract: false };
    } else {
      this.radioState[index] = { stock: false, contract: true };
    }
  }

  checkForInternalCap(sign: any) {
    const caps = ['R-14', 'R-15', 'R-16', 'R-17', 'R-18', 'R-19', 'A-37', 'A-38', 'A-46', 'A-47', 'A-48'];
    sign.showInternalCap = caps.find((v) => sign.verticalCode == v) ? true : false;
  }

  centerMap(sign) {
    const latlng = Leaflet.latLng(sign.latitude, sign.longitude);
    this.map.setView(latlng, 18); // Ajusta o mapa ao bounds
  }
}
